import { render, staticRenderFns } from "./uxUGCPanel.vue?vue&type=template&id=390dfa1a&scoped=true&"
import script from "./uxUGCPanel.vue?vue&type=script&lang=js&"
export * from "./uxUGCPanel.vue?vue&type=script&lang=js&"
import style0 from "./uxUGCPanel.vue?vue&type=style&index=0&id=390dfa1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dfa1a",
  null
  
)

export default component.exports